
import {
  formatByCountry,
  formatInputMoney,
  formatInputMoneyWithDecimal,
  parsingErrorResponse,
  replaceComma
} from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { RequestListCommodity } from "@/data/payload/api/CommodityApiRequest";
import {
  InsuranceTypeDeliveryData,
  ManualBooking
} from "@/domain/entities/Booking";
import debounce from "lodash/debounce";
import { Options, prop, Vue } from "vue-class-component";
import InfoInsurance from "@/app/ui/views/shipment/booking/component/mini-banner/info-insurance-v2.vue";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { ApiRequestList } from "@/domain/entities/MainApp";
import { CodConfigurationController } from "@/app/ui/controllers/CodConfigurationController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import Checkbox from "primevue/checkbox";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { Commodity } from "@/domain/entities/Commodity";
import { isCustomerApps } from "@/app/ui/views/track-delivery/delivery-tab/modules";
import { InsuranceController } from "@/app/ui/controllers/InsuranceController";
import { Insurance } from "@/domain/entities/Insurance";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { BulkBookingController } from "@/app/ui/controllers/BulkBookingController";
import { getMinMaxGoodsPriceFromFlag } from "../../../booking/create-booking-v3/components/detail-koli/product-price-insurance/validation";
import formatPriceRP from "@/app/infrastructures/misc/common-library/v2/FormatPriceRP";
import { configPrice } from "@/app/infrastructures/misc/common-library/modules/Price";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import { LocationController } from "@/app/ui/controllers/LocationController";
import {
  CodInternationalCountry,
  DetailCodConfigurationRetail
} from "@/domain/entities/CodConfiguration";

const countryCodeToCurrency: { [key: string]: string } = {
  ID: "IDR",
  MY: "MYR"
};
import formatInputByCountry, {
  formatRawInputByCountry,
  parseByCountry,
  resolveMoneyFormatCountry
} from "@/app/infrastructures/misc/common-library/FormatInputByCountry";
import { resolveCountry } from "@/app/infrastructures/misc/common-library/FormatByCountry";

class Props {
  formType = prop<string>({
    default: "",
    type: String
  });
  errorEmbargo = prop<any>({
    default: {
      originCity: false,
      destinationCity: false,
      productType: false,
      comodity: false,
      weightStatus: false,
      lengthStatus: false
    }
  });
  modelValue = prop<ManualBooking>({
    required: true
  });
  errorEstimationPrice = prop<any>({
    required: true
  });
  errMessagePriceOutside = prop<string>({
    default: ""
  });
  isCodAmount = prop<boolean>({
    default: false,
    type: Boolean
  });
  errorRepair = prop<any>({
    required: true
  });
  errorCodGoodsPrice = prop<boolean>({
    default: false,
    type: Boolean
  });
  isCrossCountryCod = prop<boolean>({ default: false, type: Boolean });
  prefixCurrency = prop<string>({ required: true, type: String });
}
@Options({
  emits: [
    "update:modelValue",
    "setFieldIndexEstPrice",
    "onChangeDeliveryFeeType",
    "update:errorCodGoodsPrice"
  ],
  components: {
    InfoInsurance,
    Checkbox
  },
  watch: {
    currencyFormatCountry: {
      handler(newCountry: string, oldCountry: string) {
        if (!newCountry || newCountry === oldCountry) return;

        if (this.modelValue.estimationPrice) {
          this.modelValue.estimationPrice = this.convertMoneyCountry(
            this.modelValue.estimationPrice,
            oldCountry
          );
          this.inputEstimationPrice(this.modelValue.estimationPrice);
        }

        if (this.modelValue.codAmount) {
          this.modelValue.codAmount = this.convertMoneyCountry(
            this.modelValue.codAmount,
            oldCountry
          );
          this.validateCodGoodsPrice(this.modelValue.codAmount);
        }
      }
    },
    "modelValue.destinationCity"() {
      this.recomputeServiceTypeDisabled();
    },
    "modelValue.destinationCountry.code": {
      handler: function() {
        this.getCodConfig();
        this.inputEstimationPrice(this.modelValue.estimationPrice);
        // Retail-only: refresh the service-type gating when the destination
        // country resolves/clears. Client (COD International) keeps its existing
        // config-driven flow untouched.
        if (this.isRetailBooking) {
          this.recomputeServiceTypeDisabled();
        }
      }
    },
    // Picked product type not in COD International Client config (cross-country)
    // -> force back to Non COD, mirroring the disabled selector.
    isCrossCountryProductTypeDisabled(disabled: boolean) {
      if (disabled && this.deliveryFeeType !== "non-cod") {
        this.onChangeDeliveryFeeType("non-cod");
      }
    },
    // Retail (manual) booking with non-ID origin must fall back to Non COD.
    isRetailNonIdOrigin(disabled: boolean) {
      if (disabled && this.deliveryFeeType !== "non-cod") {
        this.onChangeDeliveryFeeType("non-cod");
      }
    },
    // Retail (manual) ID origin to non-ID destination must fall back to Non COD.
    isRetailIdOriginToNonIdDest(disabled: boolean) {
      if (disabled && this.deliveryFeeType !== "non-cod") {
        this.onChangeDeliveryFeeType("non-cod");
      }
    }
  }
})
class SectionPackageDetail extends Vue.with(Props) {
  codStatusDisabled = false;
  dfodStatusDisabled = false;
  isCommodityNotFound = false;
  // deliveryFeeType = "non-cod";
  get deliveryFeeType() {
    if (this.manualBooking.isCOD && this.manualBooking.isDFOD) return "dfod";
    if (this.manualBooking.isCOD) return "cod";
    return this.errorRepair.serviceType ? "" : "non-cod";
  }
  isInsuranceBasic = true;

  get errorEstimationPriceModel() {
    return this.errorEstimationPrice;
  }
  set errorEstimationPriceModel(val: any) {
    this.$emit("update:errorEstimationPrice", val);
  }

  async mounted() {
    this.getCodConfig();

    // Retail-only base gating. Client bookings get their COD/DFOD disabled
    // state from setStatus(clientIsCod, clientIsDfod); don't override here.
    if (!this.isClientBooking) {
      this.codStatusDisabled =
        (!this.accountIsNonForeign && !this.modelValue.isInternational) ||
        this.isPOSNonCodBookingRetail ||
        this.isRetailNonIdOrigin ||
        this.isRetailIdOriginToNonIdDest;
      this.dfodStatusDisabled =
        (!this.accountIsNonForeign && !this.modelValue.isInternational) ||
        this.isPOSNonCodBookingRetail ||
        this.isRetailNonIdOrigin ||
        this.isRetailIdOriginToNonIdDest;
    }
    InsuranceController.setInsurance(new Insurance());
    this.setInsurance();
    this.isInsuranceBasic =
      BulkBookingController.detailRepairBulkBookingData.bookingData.insuranceFlag;

    await this.handleDeliveryFeeType();
    this.inputEstimationPrice(this.modelValue.estimationPrice);
    this.validateCodGoodsPrice(this.modelValue.codAmount);

    if (
      (this.isRetailNonIdOrigin || this.isRetailIdOriginToNonIdDest) &&
      this.deliveryFeeType !== "non-cod"
    ) {
      this.onChangeDeliveryFeeType("non-cod");
    }
  }

  get isPOSNonCodBookingRetail() {
    return (
      !this.getAccount.isCodBooking &&
      this.getAccount.isPOS &&
      this.formType === "manual"
    );
  }

  recomputeServiceTypeDisabled() {
    const destinationNotCod =
      typeof this.modelValue.destinationCity === "object" &&
      this.modelValue.destinationCity?.isCod !== "yes";

    if (this.isClientBooking) {
      // Client bookings follow the client COD/DFOD config, gated only by the
      // destination's COD availability. The retail-only foreign-account /
      // non-ID route terms must NOT disable COD/DFOD for client.
      this.codStatusDisabled =
        destinationNotCod || !this.clientManagement.clientIsCod;
      this.dfodStatusDisabled =
        destinationNotCod || !this.clientManagement.clientIsDfod;
      return;
    }

    const baseDisabled =
      (!this.accountIsNonForeign && !this.modelValue.isInternational) ||
      destinationNotCod ||
      this.isRetailNonIdOrigin ||
      this.isRetailIdOriginToNonIdDest;
    this.codStatusDisabled = baseDisabled;
    this.dfodStatusDisabled = baseDisabled;
  }

  get isClientBooking() {
    return (
      BulkBookingController.detailRepairBulkBookingData.bookedType === "client"
    );
  }

  // Treat as client COD/DFOD validation when the booking is a client booking
  // (bookedType client, possibly made by a POS/internal account) or the
  // logged-in account itself is a client account. Retail path (false) keeps
  // the retail COD config (listCodActive/listDfodActive).
  get isClientCodValidation() {
    return this.isClientBooking || this.dataProfile.account_type === "client";
  }

  // True only for genuine retail (POS/manual) bookings. The parent formType can
  // resolve to "manual" even for a client account when isAllClient is true, so
  // also require the booking itself not to be a client booking.
  get isRetailBooking() {
    return this.formType === "manual" && !this.isClientBooking;
  }

  // Retail (manual) booking with a non-ID origin cannot use COD/DFOD retail.
  // Only applies once a destination is selected; empty destination keeps COD enabled.
  get isRetailNonIdOrigin() {
    const originCode = (this.modelValue.originCountry?.code || "").toUpperCase();
    const destCode = (
      this.modelValue.destinationCountry?.code || ""
    ).toUpperCase();
    return (
      this.isRetailBooking && !!originCode && originCode !== "ID" && !!destCode
    );
  }

  // Retail (manual) booking from ID origin to a non-ID destination cannot use
  // COD/DFOD. Client bookings keep COD International support (handled by the
  // config-driven isCrossCountryProductTypeDisabled gate), so this is manual-only.
  get isRetailIdOriginToNonIdDest() {
    const originCode = (this.modelValue.originCountry?.code || "").toUpperCase();
    const destCode = (
      this.modelValue.destinationCountry?.code || ""
    ).toUpperCase();
    return (
      this.isRetailBooking &&
      originCode === "ID" &&
      !!destCode &&
      destCode !== "ID"
    );
  }

  get clientManagement() {
    return ClientManagementController.detailClientManagement;
  }

  setStatus(isCod = false, isDfod = false, nonCod = "") {
    this.codStatusDisabled = !isCod;
    this.dfodStatusDisabled = !isDfod;
    // this.deliveryFeeType = nonCod;
  }

  async setInsurance() {
    await this.getInsurancesTypeDelivery();
    // this.isInsuranceBasic = !this.disabledBasic;
    //this.modelValue.insurance = !this.disabledBasic ? "basic" : "free";
    this.onChangeInsurance();
  }

  get deliveryFeeTypes() {
    const retailCodDisabled =
      this.isRetailNonIdOrigin || this.isRetailIdOriginToNonIdDest;
    return [
      { name: "Non COD", value: "non-cod", disabled: false, logo: "" },
      {
        name: "Cash On Delivery",
        value: "cod",
        disabled:
          this.codStatusDisabled ||
          this.isCrossCountryProductTypeDisabled ||
          retailCodDisabled,
        logo: "cod-badge"
      },
      {
        name: "Delivery Fee on Delivery",
        value: "dfod",
        disabled:
          this.dfodStatusDisabled ||
          this.isCrossCountryProductTypeDisabled ||
          retailCodDisabled,
        logo: "dfod-badge"
      }
    ];
  }

  requestData: ApiRequestList = new ApiRequestList();
  listDataConfigurationCOD: ResponsePayloadV2 = new ResponsePayloadV2();
  isEligibleCOD = false;
  isEligibleDFOD = false;
  isInsurance = false;
  listCodActive = [] as any;
  listDfodActive = [] as any;

  async handleDeliveryFeeType() {
    if (this.deliveryFeeType === "cod" || this.deliveryFeeType === "dfod") {
      await this.fetchListConfigurationCOD();
    } else {
      this.listCodActive = [];
      this.listDfodActive = [];
    }
  }

  get disabledBasic() {
    return (
      ((this.listCodActive.ccoIsInsurance && this.deliveryFeeType === "cod") ||
        (this.listDfodActive.ccoIsInsurance &&
          this.deliveryFeeType === "dfod")) &&
      this.formType === "manual" &&
      this.dataProfile.account_type !== "client"
    );
  }

  async fetchListConfigurationCOD() {
    //call this if formtype manual dan getAccount.accountType partner
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    try {
      this.listDataConfigurationCOD = await CodConfigurationController.getList(
        new ApiRequestList({
          page: this.listDataConfigurationCOD.pagination.page,
          limit: this.listDataConfigurationCOD.pagination.limit,
          status: this.requestData.statusData.value
        })
      );
      // cod
      this.listCodActive = this.listDataConfigurationCOD.data.filter(
        (item: any) => item.ccoName === "COD Retail"
      )[0];

      // dfod
      this.listDfodActive = this.listDataConfigurationCOD.data.filter(
        (item: any) => item.ccoName === "DFOD Retail"
      )[0];

      if (this.disabledBasic) {
        this.isInsuranceBasic = !this.disabledBasic;
        this.disabledInsuranceBasic = this.disabledBasic;
        this.shippingIsProtected = this.disabledBasic;
        this.modelValue.insurance = "free";
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          err,
          this.$t("bulkBooking.codConfigurationFailed"),
          () => this.fetchListConfigurationCOD()
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  onSetFieldIndexEstPrice() {
    // setFieldIndex(14);
    this.$emit("setFieldIndexEstPrice");
  }

  onChangeInsurance() {
    this.modelValue.insurance = this.isInsuranceBasic ? "basic" : "free";
    this.$emit("update:modelValue", {
      ...this.modelValue,
      insurance: this.isInsuranceBasic ? "basic" : "free"
    });

    this.getInsurance(this.modelValue.estimationPrice);
  }

  get infoMessageDetailGoods() {
    return [
      `${this.$t("Informasi Penting COD!")} ${
        this.formType === "client" ? "Client" : "POS"
      } ${this.$t("tidak perlu menagih biaya pengiriman ke pengirim.")}`,
      `${this.$t("Informasi Penting DFOD!")} ${
        this.formType === "client" ? "Client" : "POS"
      } ${this.$t("tidak perlu menagih biaya pengiriman ke pengirim.")}`
    ];
  }

  setDeliveryType(value: string) {
    switch (value) {
      case "dfod": {
        BookingController.setCOD(true);
        BookingController.setDfod(true);
        break;
      }
      case "cod": {
        BookingController.setCOD(true);
        BookingController.setDfod(false);
        break;
      }
      default: {
        BookingController.setCOD(false);
        BookingController.setDfod(false);
        break;
      }
    }
  }

  async onChangeDeliveryFeeType(value: string) {
    BookingController.setCODAmount(0);
    this.setDeliveryType(value);
    // this.deliveryFeeType = value;
    await this.handleDeliveryFeeType();
    this.errorEstimationPriceModel = false;
    this.fullFilledCOD(this.modelValue.estimationPrice, false, true);
    this.$emit("onChangeDeliveryFeeType");
    if (this.bookingRetail && this.accountData.isPosAccount)
      this.getInsurance(this.modelValue.estimationPrice, true);
    this.errorRepair.serviceType = false;
    this.errorRepair.codAmount = false;
    this.validateCodGoodsPrice(this.modelValue.codAmount);
  }

  errorCommodity = false;

  changeCommodities() {
    this.errorCommodity = !this.modelValue.commodityCode;
    this.isCommodityNotFound = false;
    this.errorRepair.commodityCode = false;
    this.$emit("onChangeCommodities");
  }

  get manualBooking() {
    return BookingController.manualBooking;
  }

  isTabActive(value: string) {
    return value === this.deliveryFeeType;
  }

  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }

  get formatCountry(): string {
    return (
      this.modelValue.originCountry?.code ||
      AccountController.accountData?.countryCode?.toUpperCase() ||
      "ID"
    );
  }

  get currentCurrencyCountry(): string {
    return resolveMoneyFormatCountry(
      this.isCrossCountryCod
        ? this.modelValue.destinationCountry?.code
        : this.formatCountry
    );
  }

  get currencyFormatCountry(): string {
    return resolveCountry(this.currentCurrencyCountry);
  }

  convertMoneyCountry(value: string, fromCountry: string): string {
    const raw = parseByCountry(value, { country: fromCountry });
    return formatRawInputByCountry(raw, {
      type: "money",
      country: this.currencyFormatCountry
    });
  }

  formatEstimationPrice(value: string) {
    return formatInputByCountry(value, {
      type: "money",
      country: this.currentCurrencyCountry
    });
  }

  formatRupiah(value: string) {
    return formatInputMoney(value.replace(/[\D]+/g, ""));
  }

  formatRinggit(value: any) {
    return formatInputMoneyWithDecimal(value);
  }

  get placeholderItemPrice() {
    let placeholder = this.$t("bookingShipment.placeholder.itemPrice");

    if (this.bookingClientForm) {
      placeholder = "e.g 1";
    }

    return placeholder;
  }

  get placeholderCodAmount() {
    let placeholder = this.$t("bookingShipment.placeholder.codFee");

    if (this.bookingClientForm) {
      placeholder = "e.g 1";
    }

    return placeholder;
  }

  get bookingClientForm() {
    return (
      this.bookingPosForClient ||
      this.bookingClientForClient ||
      this.bookingInternalForClient
    );
  }

  get isFormBookClient() {
    return this.formType === "client";
  }

  get isFormBookManual() {
    return this.formType === "manual";
  }

  get getAccount(): any {
    return {
      accountType: AccountController.accountData.account_type,
      cityCode: AccountController.accountData.account_type_detail
        .partnerLocation
        ? AccountController.accountData.account_type_detail.partnerLocation
            .city_code
        : "",
      accountClientId: AccountController.accountData.account_type_detail.id
        ? AccountController.accountData.account_type_detail.id
        : "",
      isCodBooking:
        AccountController.accountData.account_type_detail.partnerIsCodBooking,
      accountTypeDetail: AccountController.accountData.account_type_detail,
      isPOS: AccountController.accountData.isPosAccount,
      countryCurrencySymbol:
        AccountController.accountData?.account_location
          ?.country_currency_symbol || ""
    };
  }

  get bookingPosForClient() {
    return this.isFormBookClient && this.getAccount.accountType === "partner";
  }

  get bookingClientForClient() {
    return this.isFormBookManual && this.getAccount.accountType === "client";
  }

  get bookingInternalForClient() {
    return this.isFormBookClient && this.getAccount.accountType === "internal";
  }

  automaticSetCheckbox(price: any) {
    if (this.modelValue.productName.includes("OTOPACK")) {
      this.isInsuranceBasic = true;
      this.disabledInsuranceBasic = true;
      this.shippingIsProtected = true;
      this.modelValue.insurance = "basic";
    } else {
      if (price >= 5000000 && !this.disabledBasic) {
        this.isInsuranceBasic = true;
        this.disabledInsuranceBasic = true;
        this.shippingIsProtected = false;
        this.modelValue.insurance = "basic";
      } else {
        // this.isInsuranceBasic = !this.disabledBasic;
        this.disabledInsuranceBasic = this.disabledBasic;
        this.shippingIsProtected = this.disabledBasic;
        // this.modelValue.insurance = !this.disabledBasic ? "basic" : "free";
      }
    }
  }

  validationCOD(price: any, isFromInput: boolean, isFromDeliveryType: boolean) {
    // insurance tidak aktif dan yang boleh akun selain client
    if (!this.isClientCodValidation) {
      let min = 0;
      let max = 0;

      if (this.isCrossCountryCod) {
        const { minPrice, maxPrice } = this.codConfigByDestination;

        min = Number(minPrice);
        max = Number(maxPrice);
      } else {
        const { ccoMinPrice, ccoMaxPrice } = this.listCodActive;

        min = ccoMinPrice;
        max = ccoMaxPrice;
      }

      const minMaxPrice = price < min || price > max;

      if (isFromInput || isFromDeliveryType) {
        this.errorEstimationPriceModel = price === 0 || minMaxPrice;
        this.errMsgPrice =
          price > max
            ? `${this.$t("Harga barang COD maksimum")} ${this.formatPrice(
                max
              )}, ${this.$t("cek & ubah lagi.")}`
            : `${this.$t("Harga barang COD minimum")} ${this.formatPrice(
                min
              )}, ${this.$t("cek & ubah lagi.")}`;
      }
    } else {
      // Client COD: cross-country validates against the COD International
      // Client config (codConfigByDestination); domestic validates against the
      // country-aware client min/max config (mirrors create-booking-v4 client).
      let min = 0;
      let max = 0;
      if (this.isCrossCountryCod) {
        const { minPrice, maxPrice } = this.codConfigByDestination;
        min = Number(minPrice);
        max = Number(maxPrice);
      } else {
        const clientMinMax = this.clientMinMaxConfig;
        min = clientMinMax.min;
        max = clientMinMax.max;
      }
      const minMaxPrice = price < min || price > max;
      if (isFromInput || isFromDeliveryType) {
        this.errorEstimationPriceModel = price === 0 || minMaxPrice;
        this.errMsgPrice =
          price > max
            ? `Harga barang COD maksimum ${this.formatPrice(
                max
              )}, cek & ubah lagi.`
            : `Harga barang COD minimum ${this.formatPrice(
                min
              )}, cek & ubah lagi.`;
      }
      //this.isInsuranceBasic = true;
      // this.modelValue.insurance = "basic";
      this.disabledInsuranceBasic = true;
      this.shippingIsProtected = true;
      // auto centang
    }
    // insurance aktif auto centang hanya untuk retail
    this.automaticSetCheckbox(price);
  }

  get configMinMax() {
    const type = this.bookingClientForm ? "client" : "retail";
    return getMinMaxGoodsPriceFromFlag(type);
  }

  // Country-aware client min/max config (mirrors create-booking-v4 client
  // `minMaxConfig`): resolves per-country client ranges before falling back to
  // the flat `config.client`. Country is taken from the origin, not the account.
  // Used for client COD/DFOD domestic validation.
  get clientMinMaxConfig(): { min: number; max: number } {
    const config: any = FlagsPermissionBookingV3.config_min_max_goods_price.getValue();
    const countryCode = (this.formatCountry || "ID").toUpperCase();
    const countryCodeLower = countryCode.toLowerCase();

    const countryConfig =
      config.countries?.[countryCode] ||
      config.countries?.[countryCodeLower] ||
      config[countryCode];

    const compositeKey = `client_${countryCodeLower}`;

    const range =
      countryConfig?.client ||
      (countryConfig?.min !== undefined ? countryConfig : undefined) ||
      config.client?.[countryCode] ||
      config.client?.[countryCodeLower] ||
      config[compositeKey] ||
      config.client;

    return { min: range.min, max: range.max };
  }

  get errorMessagePrice() {
    if (!this.accountIsNonForeign) {
      return this.$t("bookingShipment.validate.itemPrice");
    }

    return this.isFormBookClient
      ? `${this.$t("Harga barang minimum")} ${
          this.getAccount.countryCurrencySymbol
        }1.`
      : `${this.$t("Harga barang minimum")} ${
          this.getAccount.countryCurrencySymbol
        }10.000.`;
  }

  validationDFOD(
    price: any,
    isFromInput: boolean,
    isFromDeliveryType: boolean
  ) {
    // insurance tidak aktif dan yang boleh akun selain client
    if (!this.isClientCodValidation) {
      let min = 0;
      let max = 0;

      if (this.isCrossCountryCod) {
        const { minPrice, maxPrice } = this.codConfigByDestination;

        min = Number(minPrice);
        max = Number(maxPrice);
      } else {
        const { ccoMinPrice, ccoMaxPrice } = this.listDfodActive;

        min = ccoMinPrice;
        max = ccoMaxPrice;
      }
      const minMaxPrice =
        price < min ||
        price > max;
      if (isFromInput || isFromDeliveryType) {
        this.errorEstimationPriceModel = price === 0 || minMaxPrice;
        this.errMsgPrice =
          price > max 
            ? `${this.$t("Harga barang DFOD maksimum")} ${formatByCountry(
                max,
                {
                  type: "money",
                  country: this.formatCountry,
                  prefix: this.accountIsNonForeign ? "Rp" : "RM"
                }
              )}, ${this.$t("cek & ubah lagi.")}`
            : `${this.$t("Harga barang DFOD minimum")} ${formatByCountry(
                min,
                {
                  type: "money",
                  country: this.formatCountry,
                  prefix: this.accountIsNonForeign ? "Rp" : "RM"
                }
              )}, ${this.$t("cek & ubah lagi.")}`;
      }
    } else {
      // Client DFOD: cross-country validates against the COD International
      // Client config (codConfigByDestination); domestic validates against the
      // country-aware client min/max config (mirrors create-booking-v4 client).
      let min = 0;
      let max = 0;
      if (this.isCrossCountryCod) {
        const { minPrice, maxPrice } = this.codConfigByDestination;
        min = Number(minPrice);
        max = Number(maxPrice);
      } else {
        const clientMinMax = this.clientMinMaxConfig;
        min = clientMinMax.min;
        max = clientMinMax.max;
      }
      const minMaxPrice = price < min || price > max;
      if (isFromInput || isFromDeliveryType) {
        this.errorEstimationPriceModel = price === 0 || minMaxPrice;
        this.errMsgPrice =
          price > max
            ? `Harga barang DFOD maksimum ${this.formatPrice(
                max
              )}, cek & ubah lagi.`
            : `Harga barang DFOD minimum ${this.formatPrice(
                min
              )}, cek & ubah lagi.`;
      }
      // this.isInsuranceBasic = true;
      // this.modelValue.insurance = "basic";
      this.disabledInsuranceBasic = true;
      this.shippingIsProtected = true;
      // auto centang
    }
    // insurance aktif auto centang hanya untuk retail
    this.automaticSetCheckbox(price);
  }

  get minEstimationPrice() {
    if (!this.accountIsNonForeign) {
      return 3.2;
    }

    return this.isFormBookClient ? 1 : 10000;
  }

  isEstimationTyped = false;
  errMsgPrice = "";
  fullFilledCOD(
    goodPrice: any,
    isFromInput: boolean,
    isFromDeliveryType: boolean
  ) {
    if (this.isCodAmount && this.deliveryFeeType == "cod") {
      if (!BookingController.manualBooking.codAmount || isFromDeliveryType) {
        BookingController.manualBooking.codAmount = goodPrice;
      }
      this.onChangeCodGoodsPrice(
        BookingController.manualBooking.codAmount || goodPrice
      );
    }

    const price = parseByCountry(goodPrice || 0, {
      country: this.currentCurrencyCountry
    });

    this.errorEstimationPriceModel =
      !isFromInput &&
      price &&
      price < this.minEstimationPrice &&
      this.dataProfile.account_type !== "client";
    if (this.deliveryFeeType === "cod") {
      this.errorEstimationPriceModel = false;
      this.errMsgPrice = "";
      this.validationCOD(price, isFromInput, isFromDeliveryType);
      BookingController.setCOD(true);
      BookingController.setDfod(false);
      return;
    } else if (this.deliveryFeeType === "dfod") {
      this.errorEstimationPriceModel = false;
      this.errMsgPrice = "";
      this.validationDFOD(price, isFromInput, isFromDeliveryType);
      BookingController.setCOD(true);
      BookingController.setDfod(true);
      return;
    }
    BookingController.setCOD(false);
    BookingController.setDfod(false);
    const isEmpty = price === 0 && isFromInput;
    const isOttopack =
      this.manualBooking.productName.includes("OTOPACK") &&
      price > 0 &&
      price < 5000000;
    const minMaxValidation =
      (price > this.configMinMax.max || price < this.configMinMax.min) &&
      isFromInput;
    this.errorEstimationPriceModel = isEmpty || isOttopack || minMaxValidation;

    if (price > this.configMinMax.max && isFromInput) {
      this.errMsgPrice = this.accountIsNonForeign
        ? `Harga barang maksimum ${this.formatPrice(this.configMinMax.max)}.`
        : `Maximum item price ${this.formatPrice(this.configMinMax.max)}.`;
    }
    if (price < this.configMinMax.min && isFromInput) {
      this.errMsgPrice = this.accountIsNonForeign
        ? `Harga barang minimum ${this.formatPrice(this.configMinMax.min)}.`
        : `Minimum item price ${this.formatPrice(this.configMinMax.min)}.`;
    }
    if (
      this.manualBooking.productName.includes("OTOPACK") &&
      price > 0 &&
      price < 5000000
    ) {
      this.errMsgPrice = this.$t(
        "Harga barang harus di atas atau sama dengan  5 juta"
      );
    }
    // this.isInsuranceBasic = false;
    // this.disabledInsuranceBasic = false;
    // this.modelValue.insurance = "free";
    this.automaticSetCheckbox(price);
  }

  dataListCommodities: Commodity[] = [];
  get commodities() {
    const dataCommodityFromDetail =
      BulkBookingController.detailRepairBulkBookingData.bookingData.commodity;
    const dataCommodityValue =
      BulkBookingController.detailRepairBulkBookingData.bookingData.commodity
        .name;
    if (dataCommodityValue === this.modelValue.commodityCode?.name) {
      return [dataCommodityFromDetail];
    }
    return this.dataListCommodities.map((item) => {
      return {
        id: item.commodity_id,
        name: this.accountIsNonForeign
          ? item.commodity_name
          : item.commodity_name_en,
        nameEn: item.commodity_name_en || item.commodity_name,
        code: item.commodity_code,
        status: item.commodity_status,
        isDangerousGoods: item.isDangerousGoods,
        isQuarantine: item.isQuarantine
      };
    });
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  disabledInsuranceBasic = false;
  shippingIsProtected = false;

  fetchCommodityList = debounce(async (search: string) => {
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        search: search,
        page: 1,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.dataListCommodities = commodities.data;
  }, 250);
  async fetchCommodityListInfiniteScroll(search = "") {
    CommodityController.commodities.pagination.page++;
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        search,
        page: CommodityController.commodities.pagination.page,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.dataListCommodities.push(...commodities.data);
  }

  get isLoadingCommodity() {
    return CommodityController.isLoading;
  }

  onFocusCommodityList() {
    // this.setFieldIndex(11);
    if (!this.modelValue.commodityCode) {
      this.getCommodityList();
    }
  }

  async getCommodityList() {
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        page: 1,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.dataListCommodities = commodities.data;
  }

  get insuranceDetail() {
    return BookingController.insuranceTypeDelivery.data.find(
      (item: InsuranceTypeDeliveryData) => item.value === "basic"
    );
  }

  get insuranceProfit() {
    const premi =
      (Number(this.insuranceDetail?.cost) / 100) *
      Number(
        this.modelValue.estimationPrice.replace(/[.]/g, "").replaceAll(",", ".")
      );
    const premiRound = this.accountIsNonForeign
      ? premi
      : (Math.ceil(premi * 10) / 10).toLocaleString(undefined, {
          maximumFractionDigits: 1
        });

    const profit =
      (Number(this.insuranceDetail?.commissionPos) / 100) * Number(premiRound);
    return profit;
  }

  // insurance types
  listInsurance: any = [
    {
      name: "",
      value: ""
    }
  ];

  async getInsurancesTypeDelivery() {
    await BookingController.getInsuranceTypesDelivery({
      insuranceConfig: 2,
      originCountry: this.accountData.countryCode
    });

    this.listInsurance = BookingController.insuranceTypeDelivery.data.map(
      (e: InsuranceTypeDeliveryData) => {
        return {
          name: e.name,
          value: e.value,
          status: e.status,
          cost: e.cost,
          commissionPos: e.commissionPos,
          maxProtection: e.maxProtection
        };
      }
    );
  }

  get formData(): any {
    return {
      ...this.modelValue,
      isInsurance: this.isInsuranceBasic,
      listCodActive: this.listCodActive,
      listDfodActive: this.listDfodActive
    };
  }

  // Hanya dari input user; mount/watcher tidak boleh menimpa COD amount hasil hydrate.
  onChangeEstimationPrice(value: string) {
    if (this.isCodAmount && this.deliveryFeeType === "cod") {
      this.modelValue.codAmount = value as any;
    }
    this.inputEstimationPrice(value);
  }

  inputEstimationPrice(value: string) {
    this.fullFilledCOD(value, true, false);
    this.getInsurance(value);
  }

  get bookingRetail() {
    return this.accountData.account_type && this.formType === "manual";
  }
  get accountData() {
    return AccountController.accountData;
  }
  get isCA(): boolean {
    return isCustomerApps(this.modelValue?.sttShipmentId);
  }
  validationGetInsurance(value: number): boolean {
    return (
      !!value &&
      (this.bookingRetail || this.isCA) &&
      this.accountData.isPosAccount
    );
  }
  getInsurance = debounce(async (value = "", isChangeDeliveryType = false) => {
    value = +replaceComma(value);
    if (this.validationGetInsurance(value) || isChangeDeliveryType) {
      try {
        const params = new ApiRequestList({
          page: undefined,
          limit: undefined,
          typeInsurance: this.isInsuranceBasic ? "basic" : "free",
          goodsPrice: value,
          country: this.accountData.countryCode
        });
        if (this.bookingRetail) {
          params.accountType = "pos";
          params.accountRefId = this.accountData.account_type_detail?.id;
        }
        if (this.isCA) {
          params.accountType = "client";
          params.accountRefId = 2311;
        }

        const res = await InsuranceController.getInsurance(params);
        InsuranceController.setInsurance(res);
      } catch (error) {
        // console.log(error);
      }
    }
  }, 250);

  get insuranceData() {
    return InsuranceController.insuranceData;
  }

  get bannerInsurance() {
    return FlagsMedusa.config_banner_url_insurance_booking_retail.getValue();
  }

  get insuranceCommissionPos() {
    return formatByCountry(this.insuranceData.commisionPos || 0, {
      type: "money",
      country: this.formatCountry,
      prefix: this.accountIsNonForeign ? "Rp" : "RM"
    });
  }

  get commodityNotFoundErrorCaption() {
    if (this.isCommodityNotFound) {
      return this.$t("bookingShipment.error.commodityNotFound");
    }

    return "";
  }

  // Harga Barang COD (international COD/DFOD repair rows) ---
  get isCodGoodsPriceRow() {
    return (
      this.isCodAmount &&
      (this.deliveryFeeType === "cod") &&
      this.modelValue.isInternational === true
    );
  }

  get prefixCurrencyHargaBarangCod() {
    return this.prefixCurrency;
  }

  errCodGoodsPriceMsgLocal = "";

  get errorCodGoodsPriceCaption() {
    if (this.errorRepair.codAmount) {
      return this.errorRepair.codAmountCaption;
    }
    return this.errCodGoodsPriceMsgLocal;
  }

  get errorCodGoodsPriceModel() {
    return this.errorCodGoodsPrice;
  }
  set errorCodGoodsPriceModel(val: boolean) {
    this.$emit("update:errorCodGoodsPrice", val);
  }

  formatCodGoodsPrice(value: string) {
    return String(value ?? "").replace(/[^\d.,]/g, "");
  }

  onChangeCodGoodsPrice(value: string) {
    this.validateCodGoodsPrice(value);
  }

  validateCodGoodsPrice(value: any) {
    if (!this.isCodGoodsPriceRow) {
      this.errCodGoodsPriceMsgLocal = "";
      this.errorCodGoodsPriceModel = false;
      return;
    }

    const price = parseByCountry(value, {
      country: resolveMoneyFormatCountry(
        this.modelValue.destinationCountry.code
      )
    });

    if (!price) {
      this.errCodGoodsPriceMsgLocal = this.accountIsNonForeign
        ? "Harga Barang COD wajib diisi untuk pengiriman COD/DFOD"
        : "COD Goods Price is required for COD/DFOD shipments";
      this.errorCodGoodsPriceModel = true;
      return;
    }
    // const decimalDigits = normalized.match(/^\d+[.,](\d+)$/);
    // if (decimalDigits && decimalDigits[1].length > 2) {
    //   this.errCodGoodsPriceMsgLocal = this.accountIsNonForeign
    //     ? "Harga Barang COD maksimal 2 angka di belakang koma"
    //     : "COD Goods Price allows a maximum of 2 decimal places";
    //   this.errorCodGoodsPriceModel = true;
    //   return;
    // }
    // if (!/^\d+([.,]\d{1,2})?$/.test(normalized)) {
    //   this.errCodGoodsPriceMsgLocal = this.accountIsNonForeign
    //     ? "Format Harga Barang COD tidak valid. Isi angka saja tanpa simbol mata uang dan tanpa pemisah ribuan"
    //     : "Invalid COD Goods Price format. Enter numbers only, without currency symbols or separators";
    //   this.errorCodGoodsPriceModel = true;
    //   return;
    // }
    this.errCodGoodsPriceMsgLocal = "";
    // Local format is valid — still surface a pending backend error (e.g. Min/Max,
    // which is backend-owned per SEC-FE-01) instead of silently clearing it.
    this.errorCodGoodsPriceModel = !!this.errorRepair.codAmount;
  }

  // cod international config
  configCodInternationalClient = new DetailCodConfigurationRetail();

  async getCodConfig() {
    const res = await CodConfigurationController.getList(
      new ApiRequestList({
        page: 1,
        limit: 20,
        status: "active"
      })
    );

    const codConfig = new DetailCodConfigurationRetail(
      res.data.find(
        (config: DetailCodConfigurationRetail) =>
          config.ccoName === "COD International Client"
      )
    );

    this.configCodInternationalClient = codConfig;
  }

  get codConfigByDestination() {
    return new CodInternationalCountry(
      this.configCodInternationalClient.countries.find(
        (c) => c.countryCode === this.modelValue.destinationCountry.code
      )
    );
  }

  // Cross-country route independent of current payment method (the
  // isCrossCountryCod prop is COD-gated, so it can't drive selector disabling).
  get isCrossCountryRouteLocal(): boolean {
    const origin = (this.modelValue.originCountry?.code || "").toUpperCase();
    const destination = (
      this.modelValue.destinationCountry?.code || ""
    ).toUpperCase();
    return Boolean(origin && destination && origin !== destination);
  }

  // Cross-country COD/DFOD only: product type must be listed in the
  // "COD International Client" config (cco_product_type). Empty config /
  // product -> eligible (fail-open, matches other config-not-loaded gates).
  get isProductTypeEligibleCrossCountryCod(): boolean {
    const productType = this.modelValue.productName;
    if (!productType) return true;
    const configProductTypes = this.configCodInternationalClient.ccoProductType;
    if (!configProductTypes) return true;
    return configProductTypes
      .split(",")
      .some((item) => item.trim().toUpperCase() === productType.toUpperCase());
  }

  // COD/DFOD selector disabled when, on a cross-country route, the picked
  // product type is not in the COD International Client config. Client-only;
  // manual (POS) bookings aren't gated by COD International Client config.
  get isCrossCountryProductTypeDisabled(): boolean {
    return (
      this.formType === "client" &&
      this.isCrossCountryRouteLocal &&
      !this.isProductTypeEligibleCrossCountryCod
    );
  }

  formatPrice(value: number) {
    if (this.isCrossCountryCod) {
      const formatted = formatByCountry(value, {
        type: "money",
        country: resolveMoneyFormatCountry(
          this.modelValue.destinationCountry.code
        ),
        fractionDigits: 6,
        minFractionDigits: 0
      });

      return `${this.prefixCurrency}${formatted}`;
    }

    // Domestic: follow the origin country's currency (Rp for ID, RM for MY, ...)
    // instead of always formatting as Rp.
    const moneyCountry = this.currentCurrencyCountry;
    if (moneyCountry !== "ID") {
      const formatted = formatByCountry(value, {
        type: "money",
        country: moneyCountry,
        minFractionDigits: 0
      });
      const prefix = this.modelValue.originCountry?.currencySymbol || "RM";
      return `${prefix}${formatted}`;
    }

    return formatPriceRP(value);
  }
}

export default SectionPackageDetail;
